// src/app/features/post/postService.js
import axios from "axios";
import { base_url } from "../../../utils/axiosConfig";

const getPosts = async () => {
  const response = await axios.get(`${base_url}post`);
  return response.data;
};

export const postService = {
  getPosts,
};
